import React from "react";
import { Trans } from "react-i18next";

import { DropdownFilter } from "../../../../Common/DropdownFilter";
import { useVehicleFilters } from "./hooks/useVehicleFilters";

export const VehicleFilters = ({ vehicles, vehiclesCountTotal, vehicleFiltersData, searchFilters, setSearchFilters }) => {
  const {
    openedFilterDropdowns,
    toggleFilterDropdown,
    shouldToggleFilter,
    dropdownFilters,
    resetFilters,
  } = useVehicleFilters({ searchFilters, setSearchFilters, vehicleFiltersData, });

  return (
    <div className="filterbar">
      <div className="filtertitle-wrapper">
        <div className="filtertitle">
          {vehicles?.length ? (
            <h2>{vehicles?.length}/{vehiclesCountTotal} <Trans> Vehicles</Trans></h2>
          ) : (
            <h2>0 <Trans>Vehicles</Trans></h2>
          )}
        </div>
      </div>
      <div className="filtersection">
        <div className="filtersection-wrapper">
          <ul>
            {dropdownFilters.map((dropdown) =>
              dropdown.shouldShowDropdown && (
                <DropdownFilter
                  key={dropdown.filter}
                  openedFilterDropdowns={openedFilterDropdowns}
                  filter={dropdown.filter}
                  title={dropdown.title}
                  toggleDropdown={toggleFilterDropdown}
                  shouldToggleFilter={shouldToggleFilter}
                >
                  {dropdown.children}
                </DropdownFilter>
              ))}
          </ul>
        </div>
      </div>
      <div className="action-bottom">
        <div className="right">
          <a className={"button secondary mr-8 px-32 no-margin"} onClick={resetFilters}>
            <Trans>Reset Filters</Trans>
          </a>
        </div>
      </div>
    </div>
  );
};
